import { bp } from './breakpoint'
import { blockBuilder } from './blockBuilder'
import { chart } from './chart'
import { contextMenu } from './contextMenu'
import { classes } from './classes'
import { crossTable } from './crossTable'
import { drawer } from './drawer'
import { fileManager } from './fileManager'
import { filter } from './filter'
import { header } from './header'
import { menu } from './menu'
import { overlay } from './overlay'
import { resizer } from './resizer'
import { creator } from './creator'
import { tracking } from './tracking'
import { feedbackDetail } from './feedbackDetail'
import { passwordManager } from './passwordManager'
import { datamapImport } from './datamapImport'

export * from './breakpoint.constant'

type Module = {
	bp: typeof bp
	blockBuilder: typeof blockBuilder
	chart: typeof chart
	contextMenu: typeof contextMenu
	classes: typeof classes
	crossTable: typeof crossTable
	drawer: typeof drawer
	fileManager: typeof fileManager
	filter: typeof filter
	header: typeof header
	menu: typeof menu
	overlay: typeof overlay
	tracking: typeof tracking
	resizer: typeof resizer
	creator: typeof creator
	feedbackDetail: typeof feedbackDetail
	passwordManager: typeof passwordManager
	datamapImport: typeof datamapImport
}

export const module: Module = {
	bp,
	blockBuilder,
	chart,
	contextMenu,
	classes,
	crossTable,
	drawer,
	fileManager,
	filter,
	header,
	menu,
	overlay,
	resizer,
	creator,
	tracking,
	feedbackDetail,
	passwordManager,
	datamapImport,
}

export * from './modifier'
